import { connect } from 'react-redux';
import BankAccount from './BankAccountsCrear';
import { actions } from '../../../redux/modules/bankAccount';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.bankAccount,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(BankAccount);
